import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useCart } from '../Context/CartContext';
import { toast } from 'react-toastify';
import { FaTruck, FaLock, FaSmile, FaHeadset } from 'react-icons/fa';
import '../Components/Styles/packPage.css';

function PackPage() {
  const { packId } = useParams();
  const { addToCart, stockError, setStockError } = useCart();

  const [pack, setPack] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedGouts, setSelectedGouts] = useState({});

  useEffect(() => {
    fetch(`/api/packs.php?id=${packId}`)
      .then(res => res.json())
      .then(data => {
        if (!data) throw new Error("Pack introuvable");

        data.prix = Number(data.prix);

        const grouped = {};

        if (data.produits) {
          data.produits.forEach(p => {
            const key = p.produit_id;

            if (!grouped[key]) {
              grouped[key] = {
                produit_id: p.produit_id,
                nom: p.nom,
                image: p.image,
                quantite: p.quantite,
                quantite_unitaire: p.quantite_unitaire,
                variantes: [],
                varianteMap: {}
              };
            }

            grouped[key].variantes.push(p.gout);
            grouped[key].varianteMap[p.gout] = p.variante_option_id;
          });
        }

        const produitsGroupes = Object.values(grouped);

        const defaults = {};
        produitsGroupes.forEach(p => {
          defaults[p.produit_id] = p.variantes.length > 0 ? p.variantes[0] : null;
        });

        setSelectedGouts(defaults);
        setPack({
          ...data,
          produits: produitsGroupes
        });

        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [packId]);

  if (loading) return <p id="pack-loading">Chargement du pack...</p>;
  if (error) return <p id="pack-error">Erreur : {error}</p>;
  if (!pack) return <h2 id="pack-notfound">Pack introuvable</h2>;

  return (
    <div id="pack-page-container">
      <div id="pack-main-container">

        <div id="pack-image-section">
          {pack.image ? (
            <img
              id="pack-main-image"
              src={`/static/media/${pack.image}`}
              alt={pack.nom}
            />
          ) : (
            <p id="pack-no-image">Image du pack non disponible</p>
          )}
        </div>

        <div id="pack-info-section">
          <h1 id="pack-title">{pack.nom}</h1>
          <p id="pack-description">{pack.description}</p>
          <p id="pack-price">
            Prix du pack : {pack.prix.toFixed(2)} €
          </p>

          {stockError && (
            <div id="pack-stock-error">
              {stockError}
              <button
                id="pack-stock-error-close"
                onClick={() => setStockError(null)}
              >
                X
              </button>
            </div>
          )}

          <div id="pack-products-list">
            <h2>Contenu du pack :</h2>

            {pack.produits.map((p) => (
              <div key={p.produit_id} className="pack-product-card">

                <div className="pack-product-image">
                  <img
                    src={p.image
                      ? `/static/media/${p.image}`
                      : '/static/media/default.png'}
                    alt={p.nom}
                  />
                </div>

                <div className="pack-product-info">
                  <h3 className="pack-product-name">{p.nom}</h3>

                  {p.variantes.length > 1 && (
                    <div className="pack-gout-selection">
                      <label>Choisir le goût :</label>
                      <select
                        value={selectedGouts[p.produit_id]}
                        onChange={e =>
                          setSelectedGouts(prev => ({
                            ...prev,
                            [p.produit_id]: e.target.value
                          }))
                        }
                      >
                        {p.variantes.map((gout, idx) => (
                          <option key={idx} value={gout}>
                            {gout}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  <p className="pack-product-quantity">
                    {p.quantite} × {p.quantite_unitaire} unité{p.quantite_unitaire > 1 ? 's' : ''}
                  </p>
                </div>

              </div>
            ))}
          </div>

          <button
            id="pack-add-cart-btn"
            onClick={async () => {

              const packToAdd = {
                pack_id: pack.id,
                nom: pack.nom,
                quantity: 1,
                price: pack.prix,
                image: pack.image,
                type: 'pack',
                produits: pack.produits.map(p => {
                  const selectedVariante = selectedGouts[p.produit_id] || p.variantes[0] || Object.keys(p.varianteMap)[0];
                  return {
                    variante_option_id: p.varianteMap[selectedVariante],
                    quantite: p.quantite,
                    quantite_unitaire: p.quantite_unitaire || 1,
                  };
                })
              };
              console.log(JSON.stringify(packToAdd, null, 2));
              const success = await addToCart(packToAdd);

              if (success) {
                toast.success(`${pack.nom} ajouté au panier !`);
              }
            }}
          >
            Ajouter le pack au panier
          </button>

        </div>
      </div>
    </div>
  );
}

export default PackPage;